<!--
 * @Author: wangwang 2723008256@qq.com
 * @Date: 2023-08-11 09:06:57
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @LastEditTime: 2025-03-06 15:43:49
 * @FilePath: \jzjypc4.2\src\components\yuyueBox\yuyuebox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yuyueevm">
      <el-dialog  :visible.sync="dialogVisible" :before-close="handleClose" width="400px" top="30vh">
        <div class="yyevmContent">
          <div class="top">
            <h4>预约成功！</h4>
          </div>
          <h3>
            <!-- {{yymsg.title}} -->
            添加助教微信，领取课件!
          </h3>
          <div class="signSuccessContent">
            <div class="pic">
              <img :src="yymsg.file_url" alt="" />
            </div>
            <!-- <p>请确认已关注【{{yymsg.kemu_id == 1?'语文':'英语'}}教研小助手】公众号 以便接收直播提醒</p> -->
          </div>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  props:['yymsg'],
  inject: ["reload"],
    data(){
        return{
          dialogVisible:true,
          dqkfevm:'',//公众号二维码
          file_url:'',
        }
    },
    created(){
      console.log(this.yymsg.file_url,"anan")
      // setTimeout(()=>{
      //   this.file_url = this.yymsg.file_url
      // },100)
    },
    methods:{
      handleClose(){
        this.$emit('closeYytc')
      }
    },
}
</script>

<style lang="less" scoped>
    .yuyueevm {
    /deep/.el-dialog__header {
      padding: 0;
    }
    /deep/.el-dialog {
      margin-top: 13vh !important;
      border-radius: 22px;
    }
    /deep/.el-dialog__body {
      padding: 0;
      height: 420px;
    }
    /deep/.el-dialog__headerbtn .el-dialog__close{
      color: #FFF;
      margin-left: 5px;
    }
    .yyevmContent {
      width: 400px;
      height: 420px;
      border-radius: 20px;
      .top {
        width: 400px;
        height: 120px;
        border-radius: 20px 20px 0px 0px;
        background-image: url('../../assets/img/activeNew/tcbg.png');
        background-size: 100%;
        background-repeat: no-repeat;
        h4{
          font-size: 20px;
          color: #fff;
          text-align: center;
          line-height: 120px;
        }
      }
      h3 {
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 20px;
        text-align: center;
        font-size: 18px;
        width: 324px;
        line-height: 30px;
        color: #f6444e;
      }
      .signSuccessContent {
        overflow: hidden;
        .pic {
          margin: 0 auto;
          margin-bottom: 20px;
          width: 160px;
          height: 160px;
          border: 1px solid #dedede;
          img {
            width: 160px;
            height: 160px;
          }
        }
        p {
          text-align: center;
          width: 270px;
          margin: 0 auto;
          margin-bottom: 15px;
          text-align: center;
          font-size: 14px;
          color: #969799;
        }
      }
    }
  }
</style>